import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    CssBaseline,
    TextField,
    Link,
    Paper,
    Box,
    Grid,
    Typography,
    IconButton,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { makeStyles } from '@material-ui/core';
import Icon from '../../assets/img/icon.png';
import Banner from '../../assets/img/tagitstore_banner-01.jpg';
import Cookies from 'js-cookie';
import BusinessSelection from './business_selection';
import VerificationStep from './mobilenumber_verify';
import authApi from '../../services/auth';
import userApi from '../../services/users';
import businessApi from '../../services/business_selection';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../redux/loader/actions';
import { showSnackbar } from '../../redux/snackbar/actions';
import { setAuth } from '../../redux/common/actions';
import {
    setEncryptedCookie,
    getDecryptedCookie,
    removeCookie,
    encryptAES,
    decryptAES,
    removeNonBaseDomainCookies
} from '../../utils';
import RememberDialog from './resendLink';
import { setBusiness } from '../../redux/business/actions';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    bannerImage: {
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        [theme.breakpoints.up('md')]: {
            backgroundImage: `url(${Banner})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover'
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none !important'
        }
    },
    bg: {
        backgroundColor: '#f7f4f2'
    }
}));

function Copyright(props) {
    return (
        <Typography variant='body2' color='text.secondary' align='center' {...props}>
            {'Copyright © '}
            <Link color='inherit' href='' sx={{ textDecoration: 'none' }}>
                TAGITStore
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    );
}

const SignIn = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [step, setStep] = useState('form');
    const [businessMode, setBusinessMode] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [loginFailedModal, setLoginFailedModal] = useState(false);

    const businessCount = useSelector((state) =>
        state?.businessReducer?.items?.filter((item) => item.access_type !== 'none')
    );
    localStorage.setItem('businessCount', JSON.stringify(businessCount));
    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    const scheduleTokenRefresh = () => {
        const onSuccess = (res) => {
            if (res?.data?.status) {
                fetchBusiness();
            }
        };
        const onFailure = (err) => {
            console.log(err);
        };
        authApi.refreshToken().then(onSuccess, onFailure);
    };

    useEffect(() => {
        scheduleTokenRefresh();
        removeNonBaseDomainCookies();
    }, []);
    const fetchBusiness = useCallback(async () => {
        dispatch(showLoader());
        removeCookie('uuid');
        try {
            const response = await businessApi.getAllBusiness();
            const responseData = response?.data?.data;
            if (responseData?.length > 1) {
                setStep('business');
                dispatch(setBusiness(responseData));
                setBusinessMode('login');
                setEncryptedCookie('def', responseData, { expires: 7 });
                setEncryptedCookie('ids', responseData?.data?.data[0]?.uuid, {
                    expires: 7
                });
                setEncryptedCookie('ssoUid', responseData?.data?.data[0]?.uuid, {
                    expires: 7
                });
                setEncryptedCookie('uuid', responseData?.data?.data[0]?.uuid, {
                    expires: 7
                });
                setEncryptedCookie('ssoid', responseData?.data?.data[0]?.uuid, {
                    expires: 7
                });
            } else if (responseData) {
                editUserById(responseData[0]?.uuid);
                navigate('/home');
                dispatch(setBusiness(responseData));
                setBusinessMode('login');
                setEncryptedCookie('def', responseData, { expires: 7 });
                setEncryptedCookie('ids', responseData[0]?.uuid, {
                    expires: 7
                });
                setEncryptedCookie('uuid', responseData[0]?.uuid, { expires: 7 });
            } else {
                console.warn('Unexpected response format:', responseData);
            }
        } catch (error) {
            console.error('Error fetching pricing:', error);
        } finally {
            dispatch(hideLoader());
        }
    }, [dispatch]);
    const [sso, setSso] = useState(false);
    const ssoID = getDecryptedCookie('ssoid');
    const ssoChange = ssoID === sso;
    useEffect(() => {
        if (businessCount?.length > 1 && businessMode === 'login' && ssoChange) {
            setStep('business');
        } else if (businessCount?.length === 1 && businessMode === 'login') {
            navigate('/home');
        }
    }, [businessCount]);
    const [remember, setRemember] = useState(false);
    const [rememberUUID, setRememberUUID] = useState();
    const [rememberMsg, setRememberMsg] = useState();

    let lastSubmitTime = 0;
    const [userInteracted, setUserInteracted] = useState(false);

    useEffect(() => {
        const handleUserInteraction = () => setUserInteracted(true);

        // document.addEventListener("mousemove", handleUserInteraction);
        document.addEventListener('keydown', handleUserInteraction);
        document.addEventListener('scroll', handleUserInteraction);
        document.addEventListener('touchstart', handleUserInteraction);

        return () => {
            // document.removeEventListener("mousemove", handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
            document.removeEventListener('scroll', handleUserInteraction);
            document.removeEventListener('touchstart', handleUserInteraction);
        };
    }, []);

    const isBotDetected = () => {
        // Skip bot detection for mobile devices
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return false;
        }

        // Check for common bot indicators only on desktop
        return (
            (navigator.webdriver && !/Android|iPhone/i.test(navigator.userAgent)) ||
            !navigator.languages ||
            navigator.languages.length === 0 ||
            (/bot|crawler|spider|headless|phantom/i.test(navigator.userAgent) &&
                !/Chrome|Firefox|Safari/i.test(navigator.userAgent)) ||
            /HeadlessChrome|puppeteer|phantomjs/i.test(navigator.userAgent) ||
            (!userInteracted && !/Android|iPhone/i.test(navigator.userAgent))
        );
    };

    const handleSubmit = (formData) => {
        const now = Date.now();

        if (isBotDetected()) {
            alert('Bot access is restricted!');
            window.location.reload();
            return;
        }

        if (now - lastSubmitTime < 3000) {
            alert('Multiple rapid submissions detected!');
            window.location.reload();
            return;
        }

        lastSubmitTime = now;

        if (formData?.honeypot) {
            alert('Suspicious activity detected!');
            return;
        }

        const data = {
            email: formData?.email?.toLowerCase(),
            password: formData?.password
        };
        const encryptedData = encryptAES(data);
        dispatch(showLoader());
        removeCookie('email');
        removeCookie('password');
        removeCookie('id');
        removeCookie('ids');
        removeCookie('abc');
        removeCookie('uuid');
        removeCookie('rt');
        removeCookie('at');
        removeCookie('fdf');
        removeCookie('def');
        removeCookie('bi');
        removeCookie('print');
        removeCookie('buslap');
        removeCookie('name');
        removeCookie('proid');
        removeCookie('bss');
        removeCookie('ssoUid');
        removeCookie('ssoid');
        removeCookie('bas');
        removeCookie('bass');
        removeCookie('lll');

        console.log(userInteracted);
        const onSuccess = (res) => {
            dispatch(hideLoader());
            removeCookie('uuid');
            if (res?.data?.status === true) {
                const data = decryptAES(res?.data?.encryptedDataRes?.encryptedData, res?.data?.encryptedDataRes?.iv);
                const userId = data?.uuid;
                dispatch(
                    showSnackbar({
                        message: res?.data?.msg,
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );

                dispatch(setAuth({ isAuthenticated: true }));

                setEncryptedCookie('uuid', userId, { expires: 7 });
                setEncryptedCookie('ssoid', userId, { expires: 7 });
                setEncryptedCookie('ssoUid', res?.data?.uuids, { expires: 7 });
                formik.resetForm();
                fetchBusiness();
                editUserById(userId);
            }
        };

        const onFailure = (err) => {
            console.log(err, 'error');
            dispatch(hideLoader());
            if (!err?.response?.data?.regenerate) {
                if (err?.response?.data?.msg) {
                    setLoginFailedModal(true);
                }
            }
            setRemember(err?.response?.data?.regenerate);
            setRememberUUID(err?.response?.data?.uuid);
            setRememberMsg(err?.response?.data?.msg);
            removeCookie('email');
            removeCookie('password');
        };

        authApi.login(encryptedData).then(onSuccess).catch(onFailure);
    };
    const [hasRefresh, setHasRefresh] = useState(false);

    const validateUserToken = () => {
        dispatch(showLoader());

        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status === true) {
                fetchBusiness();
            }

            dispatch(
                setAuth({
                    isAuthenticated: true
                })
            );

            fetchBusiness();
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
        };

        authApi.validateToken().then(onSuccess, onFailure);
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            const sso = getDecryptedCookie('ssoid');
            if (!sso) {
                setStep('form');
            } else {
                setSso(sso);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [navigate]);

    useEffect(() => {
        if (!hasRefresh) {
            validateUserToken();
        }
    }, [hasRefresh, ssoChange]);

    const editUserById = async (userId) => {
        dispatch(showLoader());
        try {
            const response = await userApi.getUserId(userId);
            if (response?.data?.status) {
                setEncryptedCookie('abc', response.data.data[0].role.uuid);
                const id = response.data.data[0].role.uuid;
                setEncryptedCookie('ssoid', userId, { expires: 7 });
                setEncryptedCookie('ssoUid', userId, { expires: 7 });
                setEncryptedCookie('name', response?.data?.data[0]?.user?.uuid);
                setEncryptedCookie('id', id, { expires: 7 });
                setEncryptedCookie('fdf', response.data.data[0].user.username, {
                    expires: 7
                });
                setEncryptedCookie('puser', response.data.data[0].user.parent_user_id, {
                    expires: 7
                });
            } else {
                console.error('Error fetching user data');
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            bot: ''
        },
        validationSchema: yup.object({
            email: yup
                .string()
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email')
                .required('Email required'),
            password: yup
                .string()
                .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&^#])[A-Za-z\d@$!%*?&^#]{8,12}$/, 'Password required')
                .required('Password Required'),
            bot: yup.string()
        }),
        onSubmit: handleSubmit
    });

    useEffect(() => {
        const savedEmail = getDecryptedCookie('email');
        const savedPassword = getDecryptedCookie('password');

        if (savedEmail) {
            formik.setFieldValue('email', savedEmail);
        }
        if (savedPassword) {
            formik.setFieldValue('password', savedPassword);
        }
    }, []);

    const handleUserSubmit = () => {
        navigate('/home');
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            formik.handleSubmit();
        }
    };

    return (
        <>
            <input type='text' name='botField' style={{ display: 'none' }} />
            <Grid container component='main' sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid item xs={false} md={8} className={classes.bannerImage} />
                <Grid item xs={12} md={4} pt={5} component={Paper} elevation={6} square className={classes.bg}>
                    <Box
                        sx={{
                            my: 2,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        <Box
                            component='img'
                            src={Icon}
                            alt='logo'
                            sx={{
                                my: 2,
                                width: '75px',
                                height: 'auto',
                                maxWidth: '100%'
                            }}
                        />
                        <Typography component='h1' variant='h5'>
                            Sign in
                        </Typography>
                        <Box sx={{ mt: 1 }}>
                            <TextField
                                margin='normal'
                                required
                                fullWidth
                                id='email'
                                label='Email Address'
                                name='email'
                                autoComplete='off'
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onKeyDown={handleKeyDown}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                            <TextField
                                margin='normal'
                                required
                                fullWidth
                                id='password'
                                label='Password'
                                name='password'
                                type={showPassword ? 'text' : 'password'}
                                disabled={!formik.values.email}
                                autoComplete='off'
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onKeyDown={handleKeyDown}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <IconButton
                                                aria-label='toggle password visibility'
                                                onClick={togglePasswordVisibility}
                                                edge='end'
                                            >
                                                <VisibilityOutlinedIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button
                                variant='contained'
                                onClick={formik.handleSubmit}
                                fullWidth
                                sx={{
                                    mt: 3,
                                    background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
                                    color: '#fff',
                                    borderRadius: '8px',
                                    textTransform: 'uppercase',
                                    fontWeight: 'bold',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)'
                                    }
                                }}
                            >
                                Sign In
                            </Button>
                            <Grid container mt={1}>
                                <Grid item xs>
                                    <Link
                                        href='/forgotpassword'
                                        variant='body2'
                                        sx={{ textDecoration: 'none', color: '#6c6c6c' }}
                                    >
                                        Forgot password?
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link
                                        href='/signup'
                                        variant='body2'
                                        sx={{ textDecoration: 'none', color: '#6c6c6c' }}
                                    >
                                        {"Don't have an account? Sign Up"}
                                    </Link>
                                </Grid>
                            </Grid>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Dialog open={step === 'business'} onClose={() => setStep('form')} maxWidth='sm' fullWidth>
                <BusinessSelection
                    BackdropProps={{
                        sx: {
                            backdropFilter: 'blur(6px)', // You can adjust the blur intensity
                            backgroundColor: 'rgba(0, 0, 0, 0.4)' // Optional: add a semi-transparent overlay
                        }
                    }}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                />
            </Dialog>
            <Dialog open={step === 'verification'} maxWidth='sm' fullWidth>
                <VerificationStep
                    mobileNumber={mobileNumber}
                    setMobileNumber={setMobileNumber}
                    otp={otp}
                    setOtp={setOtp}
                    handleVerify={() => {}}
                    handleOtpSubmit={() => navigate('/home')}
                />
            </Dialog>
            <RememberDialog
                open={remember}
                onClose={() => setRemember(false)}
                message={rememberMsg}
                rememberUUID={rememberUUID}
                setRemember={setRemember}
                setRememberMsg={setRememberMsg}
                setRememberUUID={setRememberUUID}
                // onResend={handleResendLink}
            />
            <Dialog
                open={loginFailedModal}
                maxWidth='lg'
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(6px)', // You can adjust the blur intensity
                        backgroundColor: 'rgba(0, 0, 0, 0.4)' // Optional: add a semi-transparent overlay
                    }
                }}
                onClose={() => setLoginFailedModal(false)}
            >
                <DialogTitle textAlign={'center'}>
                    <ErrorOutlinedIcon sx={{ color: 'warning.main', fontSize: 50 }} />
                    <Typography fontSize={20} fontWeight={600} color='error'>
                        Login Failed
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography fontSize={18}>
                        👉 Your login attempt was unsuccessful. Please review the following possible reasons:
                    </Typography>
                    <Typography fontSize={18}>
                        👉 Incorrect Email or Password – Ensure your credentials are entered correctly.
                    </Typography>
                    <Typography fontSize={18}>
                        👉 Email Not Verified – If this is your first login, please verify your email through the link
                        sent to your inbox.
                    </Typography>
                    <Typography fontSize={18}>
                        👉 BOC Access Not Granted – Your account may not have access to BOC. Please contact your
                        administrator for access privileges.
                    </Typography>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default SignIn;
